export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Caramel Color (Powder)-a775c3601d296fc3c8544525a324682b.pdf";